<template>
  <div class="index" >
	  <top-menu v-if="defer(1)"></top-menu>
	  <!-- v-show="this.$route.path!='/news/newsDetail'" -->
	  <div  v-if="defer(2)" class="carousel_block" v-show="this.$route.path!='/aboutUs/aboutUs'">
	      <el-carousel circle trigger="click" height="700px" >
	        <el-carousel-item v-for="(item,i) in bannerData" :key="i">
					<div v-html="item.remarks" style="font-size: 2.5rem !important;font-weight: bold;color: #6A80E4;z-index: 10;position: absolute;left: 41%;margin-left: -17.5rem;top: 50%;margin-top: -4.375rem;">
					
					</div>
					<img :src="item.img[1]" style="width: 100%;height:700px;">
					<img :src="item.img[0]" style="width: 37.5rem; position: absolute;left: 50%;margin-left: -2.75rem;top: 50%;margin-top: -16rem;">
	        </el-carousel-item>
	      </el-carousel>
	    </div>
		
		<router-view v-if="defer(6)"></router-view>
		<div  v-if="defer(3)"class="white_left"></div>
		<div v-if="defer(4)" class="white_right"></div>
		<mfooter v-if="defer(5)">
			
		</mfooter>
		<returnHead>
			
		</returnHead>
  </div>
</template>
<script>
	import topMenu from '../common/topMenu'
	import mfooter from '../common/footer'
	import returnHead from '../components/returnHead.vue'
	import {banner} from '../common/api.js'
	export default {
	  name: "index",
	  data() {
	    return {
			currentNumber:1,
			banner,
			bannerData:[
				// 'http://192.168.2.232:5000/Resource/News/2021/09/29/47cdcad445b64ef6b823ddb9f42f56af.jpg',
				// 'http://192.168.2.232:5000/Resource/News/2021/09/29/47cdcad445b64ef6b823ddb9f42f56af.jpg'
			],
	    };
	  },
	  created(){
		  console.log("输出")
		  this.getBanner('1')
	  },
	  methods:{
	  async getBanner(i){
			let res = await this.banner({Postion:i})
			console.log(res.data.Data.img)
		this.bannerData=res.data.Data
		this.bannerData.map((n,i)=>{
		this.bannerData[i].img = n.img.split(";")
		})
		console.log(this.bannerData)
		console.log("ddd")
		},
		defer(number){
			if(this.$route.path!='/home'){
				return true
			}
			if(this.currentNumber>=number){
				setTimeout(()=>{
					this.currentNumber+=1
				},1000)
				return true
			}
			else{
				return false
			}
			
		},
	  },
	  
	  components:{
		  topMenu,
		  mfooter,
		  returnHead
	  },
	};
</script>
<style>
	.index{
		height: 100%;
	}
	#app{
		height: 100%;
	}
  .el-carousel__item h3 {
    color: #475669;
    font-size: 0.875rem;
    opacity: 0.75;
    line-height: 9.375rem;
    margin: 0;
  }
	.carousel_block{
		margin-top: 0.625rem;
	}
	
  .el-carousel__item:nth-child(2n) {
     background-color:#EDF0FB;
	 
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #EDF0FB;
	  
  }
  .van-tab__text{
	  font-size: 1rem;
  }
  .van-sticky{
	  box-shadow: 0 0.375rem 0.625rem 0.3125rem #f3f3f3;
	  height: 5.5rem;
  }
  .sub_menu_title{
	  display: flex;
	  justify-content: center;
	  color: #333333;
	  font-family: PingFangSC-Regular, PingFang SC;
		line-height: 4.125rem;
		font-size: 2.25rem;
		font-weight: 400;
  }
  .van-tabs__line{
	  background-color: transparent !important; 
	 
  }
  .van-tabs__wrap{
  		  height: 5.5rem !important;
  }
  .van-sticky{
	  width: 75rem;
	  margin: 0 auto;
  }
  .van-tabs__nav--complete{
	  padding:0 9.375rem !important;
  }
  .van-sticky--fixed{
  width: 75rem;
  margin: 0 auto;
  }
</style>

